import React, { useMemo } from 'react'
import CriteriaFields from '../../../../components/common/criteria/CriteriaFields'
import CriteriaList from '../../../../components/common/criteria/CriteriaList'
import { useSelector } from 'react-redux'
import submissionSelectors from '../../../../store/selectors/submission.selectors'

/**
 * Container component that renders either CriteriaFields or CriteriaList
 * with reference reasoning functionality
 */
const CriteriaWithReferencesContainer = ({
    token,
    layerId,
    patternId,
    criteria,
    setCriteria,
    regenerateReasoning,
    setFocusedCriterion,
    editable = true,
    onOpenFile,
    _patternType,
}) => {
    const currentFileId = useSelector(submissionSelectors.openedSubmissionId)

    // Process criteria with overrule data when available
    const processedCriteria = useMemo(() => {
        if (!criteria) {
            return [];
        }

        // Find matching overrule for the current file if any
        const getExistingOverrule = (criterion) => {
            if (!criterion) return null;

            // Return the overrule for the current file if one exists
            return criterion.referenceReasonings?.find(ref => 
                ref.isCurrent && ref.existingOverrule
            )?.existingOverrule;
        };

        // Apply overrule data to criteria
        return criteria.map((criterion) => {
            const overrule = getExistingOverrule(criterion);
            
            if (!overrule) return criterion;
            
            return {
                ...criterion,
                reasoning: overrule.reasoning || criterion.reasoning,
                isMet: overrule.criterion_met !== undefined ? overrule.criterion_met : criterion.isMet,
                met: overrule.criterion_met !== undefined ? overrule.criterion_met : criterion.met,
                hasOverrule: true,
                overruleData: overrule
            };
        });
    }, [criteria, currentFileId]);

    // Function to get reference reasonings for a specific criterion
    const getReferenceReasoningsForCriterion = (criterionId, _index) => {
        if (!criterionId) return []
        
        // Find the criterion by ID
        const criterion = criteria.find(c => c.id === criterionId)
        
        // Return its reference reasonings property (or empty array if none)
        return criterion?.referenceReasonings || []
    }

    // Decide which component to render based on whether the criteria is editable
    if (editable) {
        return (
            <CriteriaFields
                fields={processedCriteria}
                setFields={setCriteria}
                regenerateReasoning={regenerateReasoning}
                setFocusedCriterion={setFocusedCriterion}
                token={token}
                layerId={layerId}
                patternId={patternId}
                onOpenFile={onOpenFile}
                getReferenceReasoningsForCriterion={getReferenceReasoningsForCriterion}
            />
        );
    }

    return (
        <CriteriaList
            criteria={processedCriteria}
            token={token}
            layerId={layerId}
            patternId={patternId}
            onOpenFile={onOpenFile}
            getReferenceReasoningsForCriterion={getReferenceReasoningsForCriterion}
        />
    );
};

export default CriteriaWithReferencesContainer; 